import mutate from 'js-core/js/apollo/mutations/mutate';
import invalidateQuery from 'js-core/js/apollo/mutations/invalidateQuery';

import UpdateHarvestMutation from 'gql/mutations/Harvest/UpdateHarvest.gql';
import DeleteHarvestMutation from 'gql/mutations/Harvest/DeleteHarvest.gql';

export default class{

    static update(input) {

        return mutate(UpdateHarvestMutation, { input }, store => {

            invalidateQuery(store, 'findCohort');
        });
    }

    static delete(id) {

        return mutate(DeleteHarvestMutation, { id }, store => {

            invalidateQuery(store, 'allSections');
            invalidateQuery(store, 'findSection');
        });
    }
}
